<div class="flex-container" *ngIf="schematicDetails != null">
  <ng-container  *ngIf="isCrack == 1">
    <div class="panel__content no-padding flexcolumn" *ngIf="ObservationPointDetails != null">
      <div class="schematicName" style="display: flex; justify-content: space-between; align-items: center;">
        <div class="sch-comp">
          {{schematicDetails.Name}}
          <mat-icon class="material-icons" (click)="fileInput.click()" style="cursor: pointer;" title="Click to change schematic.&#10;Warning: Changing the schematic may affect the position or appearance of existing identified components, observation points, or cracks">edit</mat-icon>
          <input style="display: none;" type="file" #fileInput (change)="onSelectPhoto($event, schematicDetails.Id)">
        </div>
        <div class="sch-comp">
        <span class="link" (click)="openPopup()">
          Identify Comps
        </span>
        <mat-icon (click)="openPopup()" class="link" title="Identify Components">open_in_new</mat-icon>
      </div>
      </div>
      <div>
        <div class="div-hide-schematic" *ngIf="unFilteredObsPointDetails.length == 0">
          <mat-icon class="hide-schematic red-icon" title="Click to hide schematic" (click)="openHideConfirmationBox(schematicDetails.Id, schematicDetails.Name)">visibility_off</mat-icon>
        </div>
        <app-schematic-observation-points [SchematicOP]="unFilteredObsPointDetails" [schematicData]="schematicDetails" [isCrack]="1" style="position: relative;" [ImplementId]="ImplementId"
                                          (highlightobs)="highlightbospoint($event)" [selectedObsPointId]="selectedObsPointId" [releaseObsPointRow]="releaseObsPointRow"
                                          [ActiveCrackStatusIds]="activeCrackStatusIds"></app-schematic-observation-points>
      </div>
      
    </div>
    <div class="panel__content no-padding" style="overflow-x: auto; max-width: 100%; ">
      <!-- Asset Details -->
      <table class="table table--striped table--full-width">
        <thead>
          <tr>
            <th class="column250">Component Type</th>
            <th class="column250">Component</th>
            <th>Observation Point</th>
            <th *ngIf="showOPType" class="optype">OP Type</th>
            <th *ngIf="showImageHx" class="column0">{{"History" | translate | async}}</th>
            <th *ngIf="showWorn" class="column110">% Worn</th>
            <th style="display: none" *ngIf="showCrackLength" class="column110">Crack Length</th>
            <th *ngIf="showCurrentMeasure" class="column110">Current Measure</th>
            <th *ngIf="showLocationName" class="column110">{{"Location" | translate | async}}</th>
            <th *ngIf="showCrackSeverity && crackSeverityList" class="column110">Obs. Severity</th>
            <th *ngIf="showStartingDim" class="column110">Starting Dim.</th>
            <th *ngIf="showUsedLimit" class="column110">Used Limit</th>
            <th *ngIf="showBudgetLife" class="column110">Budget Life</th>
            <th *ngIf="showLife" class="column110">Life(hrs)</th>
            <th *ngIf="showResidualLife100" class="column150">Residual Life(hrs) 100%</th>
            <th *ngIf="showResidualLife120" class="column150">Residual Life(hrs) 120%</th>
            <th *ngIf="showLifeTotalProjected" class="column135">Life Total Projected</th>
            <th *ngIf="showInstallDate" class="column110">Install Date</th>
            <th *ngIf="showPartNo" class="column110">Part No.</th>
            <th *ngIf="showManufacturer" class="column110">Manufacturer</th>
            <th *ngIf="showAllCosts" class="column110">All Costs</th>
            <!-- Commented code for TT-9085 -->
            <!-- <th matTooltip="Only availible for points that have not been inspected" class="column110">Edit Points</th> -->
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let OP of ObservationPointDetails">
            <tr id="{{OP.Id}}" [ngClass]="{ 'highlightrow': selectedObsPointId == OP.Id }">
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" title="{{OP.CompTypeName}}">{{OP.CompTypeName}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" title="{{OP.ComponentName}}">
                {{OP.ComponentName}}
                <span style="font-style:italic" *ngIf="OP.isGETCritical==true">(G) </span>
                <span style="font-style:italic" *ngIf="OP.isCritical==true">(C) </span>
                <span style="font-style:italic" *ngIf="OP.isGETCritical==false && OP.isCritical==false ">(N) </span>
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" title="{{OP.Name}}">{{OP.Name}}</td>

              <td *ngIf="showOPType && OP.Type == 'Crack'" style="cursor: pointer; display: flex; align-items: baseline;" title="{{OP.ObsQuestion}}">
                <ng-container>
                  <div [ngStyle]="{ 'background-color': OP.ColorCode || '#e4351d' }" class="crack-status-badge" matTooltip="{{OP.CrackStatus}}">
                    {{OP.Type}}
                  </div>
                  <mat-icon class="material-icons" title="Change Repair status of crack" (click)="OpenCrackFixedDialog(OP)" style="cursor: pointer;">edit</mat-icon>
                </ng-container>
              </td>
              <td *ngIf="showOPType && OP.Type != 'Crack'" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" title="{{OP.ObsQuestion}}"> {{OP.Type}}</td>
              <td *ngIf="showImageHx" style="cursor: pointer;" [title]="(OP.ImageHistoryAvailable ? 'Images History' : 'No Images History') | translate | async">
                <app-component-image-history-button [module]="ModuleType.GET"
                                                    [equipmentId]="equipmentId"
                                                    [implementId]="ImplementId"
                                                    [componentId]="0"
                                                    [obsPointId]="OP.Id"
                                                    [code]=""
                                                    [imageHistoryAvailable]="OP.ImageHistoryAvailable">
                </app-component-image-history-button>
              </td>
              <td *ngIf="showWorn" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                <ng-container *ngIf="OP.Eval == ''">
                  <div class="{{getEvalClass(OP.WornPct)}}">
                    {{OP.WornPct}}%
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==3">
                  <div class="{{getEvalClass2(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==4">
                  <div class="{{getEvalClass3(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==5">
                  <div class="{{getEvalClass4(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==6">
                  <div class="{{getEvalClass5(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
              </td>

              <td *ngIf="showCrackLength" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer; display: none">{{OP.CrackLength}}</td>
              <td *ngIf="showCurrentMeasure" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CurrentLength}}</td>
              <td *ngIf="showLocationName" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.LocationName}}</td>
              <td *ngIf="showCrackSeverity && crackSeverityList" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" [matTooltip]="OP.CrackSeverity" matTooltipPosition="above">
                {{ OP.CrackSeverity?.length > 16 ? (OP.CrackSeverity | slice:0:16) + '...' : OP.CrackSeverity }}
              </td>
              <td *ngIf="showStartingDim" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.StartingDim}}</td>
              <td *ngIf="showUsedLimit" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.MaximumLength}}</td>
              <td *ngIf="showBudgetLife" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CompBudgetLife}}</td>
              <td *ngIf="showLife" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.Life}}</td>
              <td *ngIf="showResidualLife100" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife}}</td>
              <td *ngIf="showResidualLife120" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife120?.toFixed(0)}}</td>
              <td *ngIf="showLifeTotalProjected" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.LifeTotalProjected}}</td>
              <td *ngIf="showInstallDate" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.InstallDate}}</td>
              <td *ngIf="showPartNo" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.PartNo}}</td>
              <td *ngIf="showManufacturer" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.Manufacturer}}</td>
              <td *ngIf="showAllCosts" (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">$ {{OP.RepairCost}}</td>
              <!-- Commented code for TT-9085 -->
              <!-- <td>
    <div>
      <i class="material-icons" style="cursor: pointer;"
         (click)="openSchematicWindowforEdit(OP.Id, 2, schematicDetails)">edit</i>
    </div>
  </td> -->
            </tr>
          </ng-container>
        </tbody>
      </table>
      <!-- end Asset Details -->
    </div>
  </ng-container>

  <!-- Crack Registory -->
  <ng-container *ngIf="isCrack == 2 && FilerCrackObservationPointDetails!=null">
    <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
        <thead>
          <tr style="text-align-last: center;">
            <th class="right-align schematicName">
              {{schematicDetails.Name}}
              <!-- <mat-icon  style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
              (click)="openSchematicWindow(schematicDetails)">add_location_alt</mat-icon> -->
              <!-- <span style=" white-space: nowrap; "  *ngIf="sch.ObservationPoints.length >=0" >
                  <i  class="material-icons sc-icon" style="visibility: hidden;">delete</i></span> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <app-schematic-observation-points [SchematicOP]="unFilteredObsPointDetails" [schematicData]="schematicDetails" [isCrack]="2" style="position: relative;"
              [ActiveCrackStatusIds]="activeCrackStatusIds"></app-schematic-observation-points>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">

        <thead>
          <tr>
            <th style="padding: 16px 45px;text-align: left;">Component</th>
            <th style="padding: 16px 24px;text-align: left;">Observation Point</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">OP Type</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">% Worn</th>
            <th>Crack Length</th>
            <th>Current Measure</th>
            <th>Obs. Severity</th>

            <th>Starting Dim.</th>
            <th>Used Limit</th>
            <th>Budget Life</th>
            <th> Life(hrs)</th>
            <th>Residual Life(hrs)</th>
            <th>Life Total Projected</th>
            <th style="text-align: center; padding: 16px 45px;text-align: center;">Install Date</th>
            <th>Part No.</th>
            <th>Manufacturer</th>
            <th>All Costs</th>
            <th>Comments</th>
            <th matTooltip="Only availible for points that have not been inspected">Edit Points</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let OP of ObservationPointDetails">
            <tr *ngIf="OP.Type == 'Crack'">
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.ComponentName}}">{{OP.ComponentName}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.Name}}">{{OP.Name}}</td>
              <td (click)="OpenCrackFixedDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type == 'Crack'">
                <ng-container>
                  <div [ngStyle]="{ 'background-color': OP.ColorCode || '#e4351d' }" class="crack-status-badge" matTooltip="{{OP.CrackStatus}}">
                    {{OP.Type}}
                  </div>
                </ng-container>

              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type != 'Crack'"> {{OP.Type}}</td>
              <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                  <ng-container *ngIf="OP.Eval == ''">
                      <div class="{{getEvalClass(OP.WornPct)}}">
                          {{OP.WornPct}}%
                      </div>
                  </ng-container>
                  <ng-container *ngIf="OP.Eval != ''">
                      <div class="{{getEvalClass2(OP.Eval)}}">
                          {{OP.Eval}}
                      </div>
                  </ng-container>
              </td> -->
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                <ng-container *ngIf="OP.Eval == ''">
                  <div class="{{getEvalClass(OP.WornPct)}}">
                    {{OP.WornPct}}%
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==3">
                  <div class="{{getEvalClass2(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==4">
                  <div class="{{getEvalClass2('U')}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
              </td>

              <td (click)="OpenNormalObsHistroyDialog(OP)" style="text-align: center;cursor: pointer;">{{OP.CrackLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CurrentLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" [matTooltip]="OP.CrackSeverity" matTooltipPosition="above">
                {{ OP.CrackSeverity?.length > 16 ? (OP.CrackSeverity | slice:0:16) + '...' : OP.CrackSeverity }}
              </td>

              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.StartingDim}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.MaximumLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CompBudgetLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.Life}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.LifeTotalProjected}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.InstallDate}}</td>
              <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                  <ng-container>
                      <div >{{OP.InstallDate}}</div>
                  </ng-container>
              </td> -->
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.PartNo}}</div>
                </ng-container>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.Manufacturer}}</div>
                </ng-container>
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">$ {{OP.RepairCost}}</td>


              <td class="table__eval-cell">
                <ng-container *ngIf="OP.Crackcomment == null">
                  <i class="material-icons" style="cursor: pointer;" (click)="OpenCrackCommentDialog(OP)">chat_bubble</i>
                </ng-container>
                <ng-container *ngIf="OP.Crackcomment != null">
                  <i class="material-icons" style="cursor: pointer; color: green;" (click)="OpenCrackCommentDialog(OP)">chat_bubble</i>
                </ng-container>
              </td>


              <!-- <ng-container *ngIf="OP.LastInspectionDate=='Never'"> -->
              <td>
                <div style="margin-left: 30px">
                  <i class="material-icons" style="cursor: pointer;"
                     (click)="openSchematicWindowforEdit(OP.Id, 2)">edit</i>

                </div>
              </td>
              <!-- </ng-container> -->
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- end Crack Registory -->
</div>
